"use strict";

exports.wrapPageElement = require("./wrap-page");
exports.wrapRootElement = require("./wrap-root");

exports.shouldUpdateScroll = function () {
  return !window.__tl_inTransition;
};